import DualCTAVideoLanding from "@/pages/DualCTAVideoLanding";
import { RedirectWithLoadingGate } from "@/components/RedirectWithLoadingGate";
import { resolveMembershipRouteRedirect } from "@/lib/redirectLoadingSurfaces";
import { useLocation } from "react-router-dom";

type MembershipLandingLocale = "es" | "intl";

/**
 * Serves DualCTAVideoLanding on the locale-canonical membership path.
 *
 * LATAM + Spanish-default → `/ser-miembro` (Stripe USD).
 * US / intl → `/membership` (Stripe USD).
 *
 * Redirects con TemplateLoadingScreen (sin flash Mux/blank).
 * Admin preview (?_force_variant=): skips geo redirects.
 */
export function MembershipLandingRoute({ locale }: { locale: MembershipLandingLocale }) {
  const { pathname, search, hash } = useLocation();
  const isPreview = new URLSearchParams(search).has("_force_variant");

  const redirect = resolveMembershipRouteRedirect({
    pathname,
    search,
    hash,
    locale,
    isPreview,
  });

  if (redirect) {
    return (
      <RedirectWithLoadingGate
        to={redirect.to}
        reason={redirect.reason}
      />
    );
  }

  return <DualCTAVideoLanding />;
}